import { Route } from '@angular/router';
import {
  authRoutes,
  hasScopesGuard,
  rewriteTenantUrlGuard,
  tenantAuthGuard,
} from '@mds/ngx-auth';
import { deploymentRoutes } from './features/deployment/deployment.routes';
import { driverRoutes } from './features/driver/driver.routes';
import { planningRoutes } from './features/planning/planning.routes';
import { shiftRoutes } from './features/shift/shift.routes';
import { vehicleRoutes } from './features/vehicle/vehicle.routes';

export const appRoutes: Route[] = [
  {
    path: '',
    children: [
      {
        path: 'error/:code',
        loadComponent: () =>
          import('@mds/ngx-layout').then((m) => m.ErrorPageComponent),
      },
      authRoutes,
      {
        path: '',
        canActivate: [tenantAuthGuard],
        canMatch: [rewriteTenantUrlGuard],
        children: [
          {
            path: ':tenantId',
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('./features/home/components/home/home.component').then(
                    (m) => m.HomeComponent,
                  ),
              },
              {
                path: 'shifts',
                children: shiftRoutes,
                canActivate: [hasScopesGuard(['shifts:read'])],
              },
              {
                path: 'vehicles',
                children: vehicleRoutes,
                canActivate: [hasScopesGuard(['vehicles:read'])],
              },
              {
                path: 'drivers',
                children: driverRoutes,
                canActivate: [hasScopesGuard(['drivers:read'])],
              },
              {
                path: 'deployments',
                children: deploymentRoutes,
                canActivate: [hasScopesGuard(['deployments:read'])],
              },
              {
                path: 'planning',
                children: planningRoutes,
                canActivate: [hasScopesGuard(['deployments:read'])],
              },
            ],
          },
        ],
      },
      {
        path: '**',
        redirectTo: '/error/404',
      },
    ],
  },
];
